<template>
  <button v-if="subscriptionFeatureAllowed"
    class="btn btn-outline-secondary w-100"
    @click="gotoHome">
    <i class="fas fa-home"></i>
    Home
  </button>
</template>

<script>
import { SubscriptionCacheMixin } from '@/mixins/Booking/SubscriptionCacheMixin'

export default {
  name: 'HomeButton',
  mixins: [SubscriptionCacheMixin],
  computed: {
    featureKey () {
      return 'unregisteredClientBookingAllowed'
    },
    postId () {
      return this.$route.query.postId || this.$route.query.postid || ''
    }
  },
  methods: {
    gotoHome () {
      const query = { siteId: this.selectedSiteId }
      if (this.postId) query.postId = this.postId
      this.$router.push({ name: 'bookingHome', query })
        .then(() => { window.location.reload() })
    }
  }
}
</script>
